import React from "react"
import PropTypes from "prop-types"
// import { makeStyles } from '@material-ui/core/styles'
import { Circle, Polygon } from "react-leaflet"

// const useStyles = makeStyles(theme => ({
//   '@keyframes pulse': {
//     '0%': {
//       strokeWidth: 3
//     },
//     '50%': {
//       strokeWidth: 8
//     },
//     '100%': {
//       strokeWidth: 3
//     }
//   },
//   pulse: {
//     fill: '#039be5',
//     fillOpacity: 1,
//     stroke: 'white',
//     animation: '$pulse 2s infinite'
//   }
// }))

const NodeMarker = ({ handleClick, center, radius, markerColor, markerFill, role }) => {
	if (center.length !== 2) return null

	if (role === "solo") {
		return <Circle center={center} radius={radius} color={markerColor} fill={markerFill} onClick={handleClick} />
	} else if (role === "primary") {
		return (
			<Polygon
				positions={[
					[center[0], center[1] - radius],
					[center[0] - radius * 1.5, center[1]],
					[center[0], center[1] + radius],
					[center[0] + radius * 1.5, center[1]],
				]}
				color={markerColor}
				fill={markerFill}
				onClick={handleClick}
			/>
		)
	} else if (role === "aux") {
		return (
			<Polygon
				positions={[
					[center[0] - radius, center[1] - radius],
					[center[0] - radius, center[1] + radius],
					[center[0] + radius, center[1]],
				]}
				color={markerColor}
				fill={markerFill}
				onClick={handleClick}
			/>
		)
	}
}

NodeMarker.propTypes = {
	center: PropTypes.array.isRequired,
	radius: PropTypes.number.isRequired,
	handleClick: PropTypes.func.isRequired,
}

export default NodeMarker
